interface WeekFilterProps {
  weeks: Array<{ index: number; weekNumber: number; label: string }>;
  selectedWeek: number;
  setSelectedWeek: (week: number) => void;
}

export const WeekFilter = ({ weeks, selectedWeek, setSelectedWeek }: WeekFilterProps) => {
  return (
    <div className="mb-4">
      <div className="flex gap-2 overflow-x-auto pb-2">
        {weeks.map(week => (
          <button
            key={week.index}
            data-test-id={`leaderboard-week-${week.weekNumber}`}
            onClick={() => setSelectedWeek(week.index)}
            className={`
                  px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-smooth
                  ${
                    selectedWeek === week.index
                      ? 'bg-white text-gray-900'
                      : selectedWeek < week.index
                        ? 'bg-black/20 text-white hover:text-text-primary'
                        : 'bg-black/10 text-text-secondary'
                  }
                `}
          >
            {week.label}
          </button>
        ))}
      </div>
    </div>
  );
};
